import { useEffect } from 'react'
import '../../styles/pages/membership/style.css'
import AboveAll from '../../components/AboveAll'
import CustomForms from '../../components/Forms'

const CONTACT_DESCRIPTION = 'Get in touch with Life Sports Club, New Cairo. Leave your details and a member of our team will contact you.'
const DEFAULT_DESCRIPTION = 'Life Sports Club, New Cairo, 25 acres, 20+ sports, sports academies for kids & adults, Olympic pools, tennis, padel, football & more.'

export default function Contact(){
	document.title = 'LSC | Contact Us'

	useEffect(() => {
		const descTag = document.querySelector('meta[name="description"]')
		if (descTag) descTag.setAttribute('content', CONTACT_DESCRIPTION)

		return () => {
			if (descTag) descTag.setAttribute('content', DEFAULT_DESCRIPTION)
		}
	}, [])

	return (
		<>
			<AboveAll/>
			<div className="daApp">
				<div className='formsWrapper'>
					<CustomForms classes={'forms contactOnly'} show={'contact'}/>
				</div>
			</div>
		</>
	)
}
